import type { Product } from "../../aysa_api/models/product.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseProductImage,
  encodeProductImage,
  decodeProductImage,
} from "../../aysa_api/models/product_images";
import {
  encodeProductPrice,
  decodeProductPrice,
} from "../../aysa_api/models/product_price";
import {
  encodeProductColor,
  decodeProductColor,
} from "../../aysa_api/models/product_color";
import {
  encodeProductSize,
  decodeProductSize,
} from "../../aysa_api/models/product_size";
import type { Long } from "protoc-gen-ts";

export const createBaseProduct = (): Product => {
  return {
    id: 0,
    name: "",
    path: "",

    primaryBustImage: createBaseProductImage(),
    primaryModelImage: createBaseProductImage(),
    colors: [],
    colorLabel: "",
    isSoldOut: false,
    isNew: false,
    isPremium: false,
    isSponsored: false,
    isSecondHand: false,
    isExclusive: false,
    sizes: [],
    masterKey: "",
    shareUrl: "",

    captchaRequired: false,

    isAiutaEligible: false,
  };
};

export const decodeProduct = (reader: Reader, length: number): Product => {
  const end = reader.pos + length;
  const message = createBaseProduct();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;
      case 3:
        message.path = reader.string();

        break;
      case 4:
        message.price = decodeProductPrice(reader, reader.uint32());

        break;
      case 5:
        message.primaryBustImage = decodeProductImage(reader, reader.uint32());

        break;
      case 6:
        message.primaryModelImage = decodeProductImage(reader, reader.uint32());

        break;
      case 7:
        message.colors.push(decodeProductColor(reader, reader.uint32()));

        break;
      case 8:
        message.colorLabel = reader.string();

        break;
      case 16:
        message.isSoldOut = reader.bool();

        break;
      case 17:
        message.isNew = reader.bool();

        break;
      case 18:
        message.isPremium = reader.bool();

        break;
      case 19:
        message.isSponsored = reader.bool();

        break;
      case 21:
        message.isSecondHand = reader.bool();

        break;
      case 22:
        message.isExclusive = reader.bool();

        break;
      case 24:
        message.sizes.push(decodeProductSize(reader, reader.uint32()));

        break;
      case 25:
        message.masterKey = reader.string();

        break;
      case 26:
        message.shareUrl = reader.string();

        break;
      case 27:
        message.sponsoredType = reader.string();

        break;
      case 29:
        message.captchaRequired = reader.bool();

        break;
      case 30:
        message.lowStockHint = reader.string();

        break;
      case 32:
        message.isAiutaEligible = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProduct = (writer: Writer, message: Product): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);
  writer.uint32(26).string(message.path);
  if (message.price !== undefined) {
    encodeProductPrice(writer.uint32(34).fork(), message.price).ldelim();
  }
  encodeProductImage(
    writer.uint32(42).fork(),
    message.primaryBustImage
  ).ldelim();
  encodeProductImage(
    writer.uint32(50).fork(),
    message.primaryModelImage
  ).ldelim();
  for (const value of message.colors) {
    encodeProductColor(writer.uint32(58).fork(), value).ldelim();
  }
  writer.uint32(66).string(message.colorLabel);
  writer.uint32(128).bool(message.isSoldOut);
  writer.uint32(136).bool(message.isNew);
  writer.uint32(144).bool(message.isPremium);
  writer.uint32(152).bool(message.isSponsored);
  writer.uint32(168).bool(message.isSecondHand);
  writer.uint32(176).bool(message.isExclusive);
  for (const value of message.sizes) {
    encodeProductSize(writer.uint32(194).fork(), value).ldelim();
  }
  writer.uint32(202).string(message.masterKey);
  writer.uint32(210).string(message.shareUrl);
  if (message.sponsoredType !== undefined) {
    writer.uint32(218).string(message.sponsoredType);
  }
  writer.uint32(232).bool(message.captchaRequired);
  if (message.lowStockHint !== undefined) {
    writer.uint32(242).string(message.lowStockHint);
  }
  writer.uint32(256).bool(message.isAiutaEligible);

  return writer;
};
